export const STATUS_UPDATE_INTERVAL = 5000; // 5 seconds
export const DATAX_ADD_ITEM = 'add-item';
export const DATAX_DELETE_ITEM = 'delete-item';
